import React from "react";
import { Navigate } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { useAuthContext } from "../../context/AuthContext";
import {
  useEffectivePermissions,
  can,
  scopeSetFromPermissions,
} from "../../hooks/useEffectivePermissions";
import AppBootstrapErrorState from "../AppBootstrapErrorState";

function PermissionLoadingSkeleton() {
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
      <Skeleton variant="text" width={180} height={32} />
      <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={240} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

export default function Require({ resource, action = "view", children, fallback = null, redirect = "/chat" }) {
  const { userData } = useAuthContext();
  const isMasterUser = Number(userData?.master) === 1;
  const { data, isLoading, error, refetch, isFetching } = useEffectivePermissions();

  if (isLoading) {
    return fallback ?? <PermissionLoadingSkeleton />;
  }

  if (error) {
    return (
      <AppBootstrapErrorState
        error={error}
        onRetry={() => refetch()}
        isRetrying={isFetching}
        homeTo={redirect}
      />
    );
  }

  const set = scopeSetFromPermissions(data, { ...userData, master: isMasterUser ? 1 : 0 });
  return can(set, resource, action) ? children : <Navigate to={redirect} replace />;
}
